<div class="accordions-container row">
  <div class="accordion-container col-md-12 col-lg-12 col-xxxl-12">
    <nb-accordion>
      <nb-accordion-item expanded>
        <nb-accordion-item-header>
          Khóa học nhận được

          <button nbButton ghost status="danger">
            <nb-icon icon="heart"></nb-icon>
          </button>

          <span class="text-primary">{{ course.hearts | number }} </span>
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <div class="form-group">
            <label class="label">Tiêu đề</label>
            <br />
            <span style="white-space: pre-line">{{ course.title }}</span>
          </div>

          <div class="form-group">
            <label class="label">Mô tả</label>
            <br />
            <span style="white-space: pre-line">{{ course.description }}</span>
          </div>

          <div class="form-group">
            <label class="label">Mục đích</label>
            <br />
            <span style="white-space: pre-line">{{ course.purpose }}</span>
          </div>

          <div class="form-group">
            <label class="label">Tag</label>

            <nb-tag-list>
              <nb-tag
                appearance="outline"
                status="info"
                *ngFor="let tree of trees"
                [text]="tree"
              ></nb-tag>
            </nb-tag-list>
          </div>

          <div class="form-group">
            <label class="label">
              Học viên tham gia:
              <span class="text-primary">{{ course.noStudent | number }}</span>
            </label>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Học viên đánh giá: (
          <span class="text-danger">
            {{ (course.noRating ? course.noRating : 0) | number }}
          </span>
          ) &nbsp;

          <ngx-view-rating-star [rating]="course.rating"></ngx-view-rating-star>
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <ngx-view-course-rating
            [courseId]="courseId"
            [course]="course"
            [mode]="mode"
          >
          </ngx-view-course-rating>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item>
        <nb-accordion-item-header>
          Hướng dẫn: {{ course.authorName }}
        </nb-accordion-item-header>
        <nb-accordion-item-body [nbSpinner]="loading" nbSpinnerStatus="info">
          <ngx-view-profile
            [courseId]="courseId"
            [userId]="course.createdBy"
          ></ngx-view-profile>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </div>
</div>
